import { useState } from "react";
import { Gift, Loader2, Send, Check, Users, Percent, HandCoins } from "lucide-react";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const PERKS = [
  { icon: HandCoins, title: "Odměna pro vás", text: "Za každého doporučeného klienta, který si pronajme vůz, získáte odměnu." },
  { icon: Percent, title: "Sleva pro kamaráda", text: "Váš známý dostane zvýhodněné podmínky na první měsíc pronájmu." },
  { icon: Users, title: "Bez omezení", text: "Doporučte kolik lidí chcete – odměny se sčítají." },
];

const ReferralSection = () => {
  const [form, setForm] = useState({ name: "", contact: "", friend: "", friendContact: "" });
  const [sending, setSending] = useState(false);
  const [sent, setSent] = useState(false);
  const [err, setErr] = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.name || !form.contact || !form.friendContact) { setErr("Vyplňte prosím své jméno, kontakt a kontakt na doporučeného."); return; }
    setSending(true); setErr(null);
    try {
      const isEmail = form.contact.includes("@");
      const res = await fetch(`${BACKEND_URL}/api/contact`, {
        method: "POST", headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          name: form.name,
          email: isEmail ? form.contact : "",
          phone: isEmail ? "" : form.contact,
          vehicleType: "", duration: "",
          message: `[DOPORUČENÍ] ${form.name} doporučuje: ${form.friend || "—"} (kontakt: ${form.friendContact}). Doporučitel kontakt: ${form.contact}.`,
        }),
      });
      if (!res.ok) throw new Error("Odeslání se nezdařilo, zkuste to prosím znovu.");
      setSent(true);
    } catch (e2) { setErr(e2.message); } finally { setSending(false); }
  };

  return (
    <section id="referral" className="py-16 sm:py-24 px-4 sm:px-6 bg-[#0a0a0a]" data-testid="referral-section">
      <div className="max-w-5xl mx-auto">
        <div className="text-center mb-10 reveal">
          <div className="inline-flex items-center gap-2 text-orange-400 text-sm font-medium mb-3">
            <Gift className="w-4 h-4" /> <span>Doporučte a vydělejte</span>
          </div>
          <h2 className="section-title text-2xl sm:text-3xl lg:text-4xl">Znáte někoho, kdo hledá auto?</h2>
          <p className="text-zinc-400 mt-4 max-w-2xl mx-auto text-sm sm:text-base">Doporučte EffectDeal a získejte odměnu. Váš známý dostane zvýhodněné podmínky, vy odměnu za každý uzavřený pronájem.</p>
        </div>

        <div className="grid md:grid-cols-3 gap-4 mb-10 reveal reveal-delay-1">
          {PERKS.map((p) => (
            <div key={p.title} className="glass rounded-2xl p-6" data-testid="referral-perk">
              <div className="w-11 h-11 rounded-xl bg-orange-500/15 flex items-center justify-center mb-3"><p.icon className="w-5 h-5 text-orange-400" /></div>
              <h3 className="font-['Cabinet_Grotesk'] font-bold mb-1">{p.title}</h3>
              <p className="text-sm text-zinc-400">{p.text}</p>
            </div>
          ))}
        </div>

        <div className="glass rounded-2xl p-6 sm:p-8 max-w-2xl mx-auto reveal reveal-delay-2" data-testid="referral-form-wrap">
          {sent ? (
            <div className="text-center py-6" data-testid="referral-success">
              <div className="w-14 h-14 rounded-2xl bg-emerald-500/15 flex items-center justify-center mx-auto mb-4"><Check className="w-7 h-7 text-emerald-400" /></div>
              <h3 className="font-['Cabinet_Grotesk'] text-xl font-bold mb-1">Děkujeme za doporučení!</h3>
              <p className="text-zinc-400 text-sm">Ozveme se vám i vašemu známému. Odměnu vyplatíme po uzavření pronájmu.</p>
            </div>
          ) : (
            <form onSubmit={submit} className="space-y-4" data-testid="referral-form">
              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-xs text-zinc-500 mb-1.5">Vaše jméno *</label>
                  <input value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-orange-500" placeholder="Jan Novák" data-testid="referral-name" />
                </div>
                <div>
                  <label className="block text-xs text-zinc-500 mb-1.5">Váš e-mail nebo telefon *</label>
                  <input value={form.contact} onChange={(e) => setForm({ ...form, contact: e.target.value })} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-orange-500" placeholder="jan@email.cz / +420…" data-testid="referral-contact" />
                </div>
                <div>
                  <label className="block text-xs text-zinc-500 mb-1.5">Jméno doporučeného</label>
                  <input value={form.friend} onChange={(e) => setForm({ ...form, friend: e.target.value })} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-orange-500" placeholder="Petr Svoboda" data-testid="referral-friend" />
                </div>
                <div>
                  <label className="block text-xs text-zinc-500 mb-1.5">Kontakt na doporučeného *</label>
                  <input value={form.friendContact} onChange={(e) => setForm({ ...form, friendContact: e.target.value })} className="w-full bg-white/5 border border-white/10 rounded-xl px-4 py-2.5 text-sm text-white placeholder-zinc-500 focus:outline-none focus:border-orange-500" placeholder="petr@email.cz / +420…" data-testid="referral-friend-contact" />
                </div>
              </div>
              {err && <p className="text-red-400 text-sm" data-testid="referral-error">{err}</p>}
              <button type="submit" disabled={sending} className="btn-accent w-full inline-flex items-center justify-center gap-2 disabled:opacity-60" data-testid="referral-submit">
                {sending ? <Loader2 className="w-4 h-4 animate-spin" /> : <Send className="w-4 h-4" />} Odeslat doporučení
              </button>
              <p className="text-[11px] text-zinc-600 text-center">Odesláním souhlasíte se zpracováním kontaktních údajů pro účely doporučení.</p>
            </form>
          )}
        </div>
      </div>
    </section>
  );
};

export default ReferralSection;
